"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ReportsRoute_1 = __importDefault(require("./ReportsRoute"));
class EmbedReportRoute {
    static get path() {
        return `${ReportsRoute_1.default.path}/:folderId`;
    }
    static dashboardQueryString(folderId, dashboardId) {
        return `${ReportsRoute_1.default.path}/${folderId}?dashboardId=${dashboardId}`;
    }
    static lookQueryString(folderId, lookId) {
        return `${ReportsRoute_1.default.path}/${folderId}?lookId=${lookId}`;
    }
}
exports.default = EmbedReportRoute;
